var render, staticRenderFns
import script from "./CurrencySelectObject.vue?vue&type=script&lang=js"
export * from "./CurrencySelectObject.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelectObject.vue?vue&type=style&index=0&id=51a6cd7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports